import React, {useEffect, useState} from 'react';
import styles from './ServicePrices.scss';
import {useServicePriceContext} from "@contexts/ContextServicePriceProvider";
import Service from "@components/base/Service/Service";
import Slider from '@components/base/Slider/Slider';
import ContentB4 from "@components/blocks/ContentB4/ContentB4";
import TermSelector from "@components/base/TermSelector/TermSelector";

const ServicePrices = ({data, color = ''}) => {

	if (!data || !data.sliderSettings || !data.plans || data.plans.length === 0) {
		return;
	}

	const services = data.plans;
	const [selectedTerm, setSelectedTerm] = useState(data.terms?.selected ?? 12);
	const contextPrice = useServicePriceContext();

	// Reload prices with promo discount for plans that define a promoCode.
	// Runs once on mount: data/services come from static data files and never change,
	// and contextPrice is intentionally omitted - it changes after every mergePrices(),
	// so listing it would re-trigger the request in a loop.
	useEffect(() => {
		const terms = (data.terms?.options ?? []).map((option) => option.id).filter(Boolean);
		const servicesByPromoCode = {};

		services.forEach((service) => {
			if (!service.promoCode || !service.serviceId) {
				return;
			}
			servicesByPromoCode[service.promoCode] = servicesByPromoCode[service.promoCode] || [];
			servicesByPromoCode[service.promoCode].push(service.serviceId);
		});

		Object.entries(servicesByPromoCode).forEach(([promoCode, serviceIds]) => {
			contextPrice.loadPricesForServiceIds(serviceIds, terms, null, null, promoCode);
		});
	}, []);

	return (
	  <>
		  {/* PLANS CONTAINER */}
		  {/*///////////////////////////////////////////////////////////////////////////////*/}
		  <div id="servicePrices" className={`${styles.container} ${services.length > 3 ? styles.containerMany : ''}`}>
			  <Slider
				slidesPerView={'auto'}
				mousewheel={data.sliderSettings.mousewheel}
				wheelReleaseDelay={data.sliderSettings.wheelReleaseDelay}
				autoplay={data.sliderSettings.autoplay}
				centerInsufficientSlides={data.sliderSettings.centerInsufficientSlides}
				initialSlide={data.sliderSettings.initialSlide}
				centeredSlides={data.sliderSettings.centeredSlides}
				centeredSlidesBounds={data.sliderSettings.centeredSlidesBounds}
				//startHintAnimation={data.startHintAnimation}
				//hintAnimationParams={data.hintAnimationParams}
			  >
				  {services.map((props, i) => (
					<Service key={i} term={selectedTerm} color={color} {...props} />
				  ))}
			  </Slider>
		  </div>

		  {/* TERM SELECTOR CONTAINER */}
		  {/*///////////////////////////////////////////////////////////////////////////////*/}
		  {data.terms?.options && data.terms?.options.length > 0 &&
			<TermSelector
			  data={data.terms}
			  selectedTerm={selectedTerm}
			  onChange={setSelectedTerm}
			  color={color}
			/>
		  }

		  {/* NOTES */}
		  {/*///////////////////////////////////////////////////////////////////////////////*/}
		  {data.noteData && data.noteData.length > 0 &&
			<div className={'baseMarginTop baseMarginLeft baseMarginRight'}>
				<ContentB4 data={data.noteData} size={'800'} color={color}/>
			</div>
		  }
	  </>
	)
}

export default ServicePrices;
